import IncidentCreated from './IncidentCreated';
import PredefinedItem from './Predefined';
import PreformattedItem from './Preformatted';
import LocationItem from './Location';
import SimpleText from './SimpleText';
import BinaryItem from './Binary';
import QuestionItem from './Question';
import AnswerItem from './Answer';

export {
  IncidentCreated,
  PredefinedItem,
  PreformattedItem,
  LocationItem,
  SimpleText,
  BinaryItem,
  QuestionItem,
  AnswerItem,
};

export default {
  IncidentCreated,
  PredefinedItem,
  PreformattedItem,
  Location,
  SimpleText,
  BinaryItem,
  QuestionItem,
  AnswerItem,
};
